<swiper-container
  class="image-banner-swiper"
  grab-cursor="true"
  centered-slides="true"
  slides-per-view="auto"
  pagination="true"
  pagination-type="bullets"
  pagination-dynamic-bullets="true"
>

  @for (image of images; track image) {

    <swiper-slide>
      <img
        [src]="image || 'assets/img/backgrounds/empty_background.jpg'"
        alt="--"
        (click)="openImage(image)"/>
    </swiper-slide>

  } @empty {

    <swiper-slide>
      <img src="assets/img/backgrounds/empty_background.jpg" alt="--"/>
    </swiper-slide>

  }

</swiper-container>
